var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.78 72.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#000;stroke-width:2px;}.cls-1{stroke-miterlimit:10;}.cls-2,.cls-3{stroke-linejoin:round;}.cls-3{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 10.59,
    cy: 66.14,
    rx: 10.02,
    ry: 4.78,
    transform: "translate(-21.2 7.18) rotate(-19.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,62.74,22.42,61a5.62,5.62,0,0,0,2.4-4.61V45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.82,1h0a4,4,0,0,1,4,4V43.48A1.55,1.55,0,0,1,27.23,45H22.41a1.55,1.55,0,0,1-1.55-1.55V5a4,4,0,0,1,4-4Z",
    transform: "translate(49.64 46.04) rotate(-180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.78,
    y1: 31.31,
    x2: 20.85,
    y2: 31.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset13);
export default __webpack_public_path__ + "static/media/Asset 13.9b30e063a6dbf92b19c5934619b809cc.svg";
export { ForwardRef as ReactComponent };